<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      { 'expanded': !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered) },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light'
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">

          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <router-link
              class="navbar-brand"
              to="/site/dashboard"
            >
              <span class="brand-logo">
                <!-- <b-img
                  :src="appLogoImage"
                  alt="logo"
                /> -->
                <b-img
                  :src="`${baseURL}assets/images/logo/logo.svg`"
                  alt="logo"
                />
                <!-- <vuexy-logo /> -->
              </span>
              <h2 class="brand-text">
                {{ appName }}
              </h2>
            </router-link>
          </li>

          <!-- Toggler Button -->
          <li class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon
                icon="XIcon"
                size="20"
                class="d-block d-xl-none"
                @click="toggleVerticalMenuActive"
              />
              <feather-icon
                :icon="collapseTogglerIconFeather"
                size="20"
                class="d-none d-xl-block collapse-toggle-icon"
                @click="toggleCollapsed"
              />
            </b-link>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div
      :class="{'d-block': shallShadowBottom}"
      class="shadow-bottom"
    />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="evt => { shallShadowBottom = evt.srcElement.scrollTop > 0 }"
    >
    <vertical-nav-menu-items
        :items="dashboardNnavMenuItems"
        class="navigation navigation-main mt-2"
      />
      <ul class="navigation navigation-main">
        <li class="navigation-header text-truncate">My Subscription</li>
        <li class="nav-item has-sub" :class="{ 'open': menu.collapse, 'sidebar-group-active': checkActiveMenu(menu) }" v-for="(menu, index) in getUserEnrollmentNavMenuItems" :key="index">
          <b-link class="d-flex align-items-center" @click="toggleSubMenu(menu)">
            <feather-icon :icon="menu.icon || 'CircleIcon'" />
            <span class="menu-title text-truncate">{{ menu.title }}</span>
          </b-link>
          <b-collapse :visible="menu.collapse" class="menu-content" tag="ul" v-if="menu.children.length">
            <li class="nav-item" :class="{ 'active': checkActiveMenu(subMenu), 'has-sub': subMenu.children, 'open': subMenu.collapse, 'sidebar-group-active': checkActiveMenu(menu) }" v-for="(subMenu, childIndex) in menu.children" :key="childIndex">
              <router-link :to="subMenu.path" class="d-flex align-items-center" v-if="subMenu.path">
                <feather-icon :icon="subMenu.icon" />
                <span class="menu-title text-truncate">{{ subMenu.title }}</span>
              </router-link>
              <b-link class="d-flex align-items-center" @click="toggleSubMenu(subMenu)" v-if="subMenu.children">
                <feather-icon :icon="subMenu.icon || 'CircleIcon'" />
                <span class="menu-title text-truncate">{{ subMenu.title }}</span>
              </b-link>
              <b-collapse :visible="subMenu.collapse" class="menu-content" tag="ul" v-if="subMenu.children">
                <li class="nav-item" :class="{ 'active': checkActiveMenu(subSubMenu) }" v-for="(subSubMenu, child2Index) in subMenu.children" :key="child2Index">
                  <router-link :to="subSubMenu.path" class="d-flex align-items-center" v-if="subSubMenu.path">
                    <span class="menu-title text-truncate">{{ subSubMenu.title }}</span>
                  </router-link>
                </li>
              </b-collapse>
            </li>
          </b-collapse>
        </li>
      </ul>

      <vertical-nav-menu-items
        :items="navMenuItems"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    

    <!-- /main menu content-->
  </div>
</template>

<script>
import dashboardNnavMenuItems from '@/navigation/vertical/dashboard'
import navMenuItems from '@/navigation/vertical'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BLink, BImg } from 'bootstrap-vue'
import { provide, computed, ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import { $themeConfig } from '@themeConfig'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import RestApi, { studyPressBaseUrl } from '@/config/api_config'
import ModalBaseMasterList from '@core/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
    VuexyLogo
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      baseURL: studyPressBaseUrl,
      userEnrollmentMenus: [],
      enrollmentMenus: [],
    }
  },
  computed: {
    getNavMenus: function () {
      const navMenus =  this.getNavMenuItems.map((item, index) => {
        item.id = `index-${index}`
        if (item.children) {
          item.children.map((child, childIndex) => {
            child.id = `index-${index}-child-${childIndex}`
            if (child.children) {
              child.children.map((child2, child2Index) => {
                child2.id = `index-${index}-child-${childIndex}-child2-${child2Index}`
                return Object.assign(child2)
              })
            }
            return Object.assign(child)
          })
        }
        return Object.assign(item)
      })
      // console.log('navMenus', navMenus)
      return navMenus
    },
    getNavMenuItems: function () {
      const userEnrollmentMenus = this.cn(this.$store.state,'userEnrollment', null)
      let myUserEnrollmentMenus = [{
        header: 'My Subscription',
      }]

      if (userEnrollmentMenus.length) {
        userEnrollmentMenus.forEach(item => {
          if (item.category) {
            const menuItem = {
                title: item.category.name,
                icon: 'UserIcon',
                tag: 9,
                tagVariant: 'light-success',
                children: [
                  {
                    title: 'Read & Practice',
                    icon: 'BookIcon',
                    route: {name: 'practice_subject_list', params: { id: item.category.id }},
                  },
                  {
                    title: 'Previous Job Test',
                    icon: 'CalendarIcon',
                    route: {name: 'my_panel_previous_year_model_test_list_by_category', params: { id: item.category.id }},
                  },
                  {
                    title: 'Model Test',
                    icon: 'LayersIcon',
                    route: {name: 'model_test_all_list_by_category', params: { id: item.category.id }},
                  },
                  {
                    title: 'Mistake List',
                    icon: 'AlertOctagonIcon',
                    route: {name: 'my_panel_mistake_list', params: { id: item.category.id }},
                  },
                  {
                    title: 'Review List',
                    icon: 'BookmarkIcon',
                    route: {name: 'my_panel_review_list', params: { id: item.category.id }},
                  },
                  {
                    title: 'Reports',
                    icon: 'FlagIcon',
                    children: [
                      {
                        title: 'Quiz Result',
                        route: {name: 'my_panel_chapter_quiz_list', params: { id: item.category.id }},
                      },
                      {
                        title: 'Model Test Result',
                        route: {name: 'my_panel_model_test_list', params: { id: item.category.id }},
                      },
                      {
                        title: 'Job Test Result',
                        route: {name: 'my_panel_previous_question_list', params: { id: item.category.id }},
                      },
                      // {
                      //   title: 'Progress Report',
                      //   route: {name: 'practice_subje_list', params: { id: item.category.id }},
                      // },
                    ],
                  },
                ],
              }
            myUserEnrollmentMenus.push(menuItem)
          }
        })
      }

      let myNewNaveMenuItems = [...myUserEnrollmentMenus, ...navMenuItems]
      // let myNewNaveMenuItems = navMenuItems.splice(2, 0, myUserEnrollmentMenus)
      // console.log('myNewNaveMenuItems ====>', myNewNaveMenuItems)
      return myNewNaveMenuItems
    },
    getUserEnrollmentNavMenuItems: function () {
      const userEnrollmentMenus = this.cn(this.$store.state,'userEnrollment', null)
      this.enrollmentMenus = []

      if (userEnrollmentMenus.length) {
        userEnrollmentMenus.forEach(item => {
          if (item.category) {
            const menuItem = {
                title: item.category.name,
                icon: 'UserIcon',
                tag: 9,
                tagVariant: 'light-success',
                id: item.category.id,
                collapse: false,
                active: false,
                children: [
                  {
                    title: 'Read & Practice',
                    icon: 'BookIcon',
                    route: {name: 'practice_subject_list', params: { id: item.category.id }},
                    path: `/site/practice_subject_list/${item.category.id}`,
                    id: item.category.id,
                    active: false,
                  },
                  {
                    title: 'Previous Job Test',
                    icon: 'CalendarIcon',
                    route: {name: 'my_panel_previous_year_model_test_list_by_category', params: { id: item.category.id }},
                    path: `/site/my_panel/previous_year_model_test_list_by_category/${item.category.id}`,
                    id: item.category.id,
                    active: false,
                  },
                  {
                    title: 'Model Test',
                    icon: 'LayersIcon',
                    route: {name: 'model_test_all_list_by_category', params: { id: item.category.id }},
                    path: `/site/model_test/all_list_by_category/${item.category.id}`,
                    id: item.category.id,
                    active: false,
                  },
                  {
                    title: 'Mistake List',
                    icon: 'AlertOctagonIcon',
                    route: {name: 'my_panel_mistake_list', params: { id: item.category.id }},
                    path: `/site/my_panel/mistake_list/${item.category.id}`,
                    id: item.category.id,
                    active: false,
                  },
                  {
                    title: 'Review List',
                    icon: 'BookmarkIcon',
                    route: {name: 'my_panel_review_list', params: { id: item.category.id }},
                    path: `/site/my-panel/review_list/${item.category.id}`,
                    id: item.category.id,
                    active: false,
                  },
                  {
                    title: 'Reports',
                    icon: 'FlagIcon',
                    id: item.category.id,
                    collapse: false,
                    children: [
                      {
                        title: 'Quiz Result',
                        icon: 'FlagIcon',
                        route: {name: 'my_panel_chapter_quiz_list', params: { id: item.category.id }},
                        path: `/site/my-panel/chapter-quiz-list/${item.category.id}`,
                        id: item.category.id,
                        active: false,
                      },
                      {
                        title: 'Model Test Result',
                        icon: 'FlagIcon',
                        route: {name: 'my_panel_model_test_list', params: { id: item.category.id }},
                        path: `/site/my-panel/model_test_result/${item.category.id}`,
                        id: item.category.id,
                        active: false,
                      },
                      {
                        title: 'Job Test Result',
                        icon: 'FlagIcon',
                        route: {name: 'my_panel_previous_question_list', params: { id: item.category.id }},
                        path: `/site/my-panel/previous-question-list/${item.category.id}`,
                        id: item.category.id,
                        active: false,
                      },
                      // {
                      //   title: 'Progress Report',
                      //   route: {name: 'practice_subje_list', params: { id: item.category.id }},
                      // },
                    ],
                  },
                ],
              }
            this.enrollmentMenus.push(menuItem)
          }
        })
      }
      return this.enrollmentMenus
    },
    isGroupOpen: function() {
      const currentRouteId = this.$route.params.id
      if(itemMenu && itemMenu.id === currentRouteId) {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    // this.getAuthData()
    // console.log('this.$store.state.userEnrollment ====>', this.$store.state.userEnrollment)
    // console.log('this.$route.params.id', this.$route)
  },
  methods: {
    toggleSubMenu: function (menu) {
      menu.collapse = !menu.collapse
    },
    checkMenuCollapse: function (itemMenu) {
      const currentRoutePath = this.$route.path
      let currentRouteId = ''

      this.enrollmentMenus.map(menu => {
        if (menu.children) {
          menu.children.map(subMenu => {
            if (subMenu.children) {
              subMenu.children.map(subSubMenu => {
                if (subSubMenu.path == currentRoutePath) {
                  currentRouteId = subSubMenu.id
                }
              })
            } else if (subMenu.path == currentRoutePath) {
              currentRouteId = subMenu.id
            }
          })
        }
      })

      this.enrollmentMenus.map(menu => {
        if (menu.id == currentRouteId) {
          menu.collapse = true
        }
        return Object.assign(menu)
      })
      
      if(itemMenu && itemMenu.id == currentRouteId) {
        return true
      } else {
        return false
      }
    },
    checkSubMenuCollapse: function (itemSubMenu) {
      const currentRoutePath = this.$route.path
      let currentRouteId = ''

      this.enrollmentMenus.map(menu => {
        if (menu.children) {
          menu.children.map(subMenu => {
            if (subMenu.children) {
              subMenu.children.map(subSubMenu => {
                if (subSubMenu.path == currentRoutePath) {
                  currentRouteId = subSubMenu.id
                }
              })
            } else if (subMenu.path == currentRoutePath) {
              currentRouteId = subMenu.id
            }
          })
        }
      })

      this.enrollmentMenus.map(menu => {
        if (menu.id == currentRouteId) {
          menu.collapse = true
        } else {
          menu.children.map(subMenu => {
            if (subMenu.id == currentRouteId) {
              subMenu.children.map(subSubMenu => {
                if (subSubMenu.path == currentRoutePath) {
                  currentRouteId = subSubMenu.id
                }
                return Object.assign(subSubMenu)
              })
            } else if (subMenu.path == currentRoutePath) {
              currentRouteId = subMenu.id
            }
            return Object.assign(subMenu)
          })
        }
        return Object.assign(menu)
      })
      
      if(itemSubMenu && itemSubMenu.id == currentRouteId) {
        return true
      } else {
        return false
      }
    },
    checkActiveMenu: function (itemMenu) {
      const currentRoutePath = this.$route.path
      // console.log('itemMenu', itemMenu)
      if(itemMenu && itemMenu.path == currentRoutePath) {
        return true
      } else {
        return false
      }
    }
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props)

    const { skin } = useAppConfig()

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false)

    provide('isMouseHovered', isMouseHovered)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'CircleIcon' : 'DiscIcon'))

    // App Name
    const { appName, appLogoImage } = $themeConfig.app

    return {
      navMenuItems,
      dashboardNnavMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
.navigation li {
    position: relative;
    white-space: nowrap;
    font-size: 13px;
    font-weight: 600;
}
.main-menu.menu-light .navigation .navigation-header {
    margin: 18px !important;
}
</style>
